// extracted by mini-css-extract-plugin
export default {"menuHolder":"menuHolder-LwgA7","menu":"menu-rnvGH"};